import { loadModules } from 'esri-loader';

import _esriRequest from '@arcgis/core/request';

import * as _esriGeometryEngine from '@arcgis/core/geometry/geometryEngine';
import * as _esriProjection from '@arcgis/core/geometry/projection';
import * as _esriWatchUtils from '@arcgis/core/core/watchUtils';

import _esriIdentityManager from '@arcgis/core/identity/IdentityManager';

import _Attribution from '@arcgis/core/widgets/Attribution';
import _BasemapGallery from '@arcgis/core/widgets/BasemapGallery';
import _BasemapToggle from '@arcgis/core/widgets/BasemapToggle';
import _ClassBreaksRenderer from '@arcgis/core/renderers/ClassBreaksRenderer';
import _Compass from '@arcgis/core/widgets/Compass';
import _CoordinateConversion from '@arcgis/core/widgets/CoordinateConversion';
import _Draw from '@arcgis/core/views/draw/Draw';
import _Editor from '@arcgis/core/widgets/Editor';
import _Expand from '@arcgis/core/widgets/Expand';
import _Extent from '@arcgis/core/geometry/Extent';
import _FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import _ImageryLayer from '@arcgis/core/layers/ImageryLayer';
import _FeatureSet from '@arcgis/core/rest/support/FeatureSet';
import _GeoJSONLayer from '@arcgis/core/layers/GeoJSONLayer';
import _Geometry from '@arcgis/core/geometry/Geometry';
import _Geoprocessor from '@arcgis/core/tasks/Geoprocessor';
import _Graphic from '@arcgis/core/Graphic';
import _GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import _GroupLayer from '@arcgis/core/layers/GroupLayer';
import _Home from '@arcgis/core/widgets/Home';
import _LayerList from '@arcgis/core/widgets/LayerList';
import _Locate from '@arcgis/core/widgets/Locate';
import _Map from '@arcgis/core/Map';
import _MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import _MapView from '@arcgis/core/views/MapView';
import _Measurement from '@arcgis/core/widgets/Measurement';
import _Point from '@arcgis/core/geometry/Point';
import _Polygon from '@arcgis/core/geometry/Polygon';
import _Circle from '@arcgis/core/geometry/Circle';
import _Polyline from '@arcgis/core/geometry/Polyline';
import _Query from '@arcgis/core/rest/support/Query';
import _QueryTask from '@arcgis/core/tasks/QueryTask';
import _RasterData from '@arcgis/core/rest/support/RasterData';
import _ScaleBar from '@arcgis/core/widgets/ScaleBar';
import _SceneView from '@arcgis/core/views/SceneView';
import _Search from '@arcgis/core/widgets/Search';
import _SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import _SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import _SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import _SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import _Sketch from '@arcgis/core/widgets/Sketch';
import _SketchViewModel from '@arcgis/core/widgets/Sketch/SketchViewModel';
import _Slider from '@arcgis/core/widgets/Slider';
import _SnappingOptions from '@arcgis/core/views/interactive/snapping/SnappingOptions';
import _SpatialReference from '@arcgis/core/geometry/SpatialReference';
import _Symbol from '@arcgis/core/symbols/Symbol';
import _TileLayer from '@arcgis/core/layers/TileLayer';
import _Widget from '@arcgis/core/widgets/Widget';
import _Field from '@arcgis/core/layers/support/Field';

export let esriRequest = _esriRequest;

export let esriGeometryEngine = _esriGeometryEngine;
export let esriProjection = _esriProjection;
export let esriWatchUtils = _esriWatchUtils;

export let esriIdentityManager = _esriIdentityManager;

export let Attribution = _Attribution;
export type Attribution = __esri.Attribution;
export let BasemapGallery = _BasemapGallery;
export type BasemapGallery = __esri.BasemapGallery;
export let BasemapToggle = _BasemapToggle;
export type BasemapToggle = __esri.BasemapToggle;
export let ClassBreaksRenderer = _ClassBreaksRenderer;
export type ClassBreaksRenderer = __esri.ClassBreaksRenderer;
export let Compass = _Compass;
export type Compass = __esri.Compass;
export let CoordinateConversion = _CoordinateConversion;
export type CoordinateConversion = __esri.CoordinateConversion;
export let Draw = _Draw;
export type Draw = __esri.Draw;
export let Editor = _Editor;
export type Editor = __esri.Editor;
export let Expand = _Expand;
export type Expand = __esri.Expand;
export let Extent = _Extent;
export type Extent = __esri.Extent;
export let FeatureLayer = _FeatureLayer;
export type FeatureLayer = __esri.FeatureLayer;
export let ImageryLayer = _ImageryLayer;
export type ImageryLayer = __esri.ImageryLayer;
export let FeatureSet = _FeatureSet;
export type FeatureSet = __esri.FeatureSet;
export let GeoJSONLayer = _GeoJSONLayer;
export type GeoJSONLayer = __esri.GeoJSONLayer;
export let Geometry = _Geometry;
export type Geometry = __esri.Geometry;
export let Geoprocessor = _Geoprocessor;
export type Geoprocessor = __esri.Geoprocessor;
export let Graphic = _Graphic;
export type Graphic = __esri.Graphic;
export let GraphicsLayer = _GraphicsLayer;
export type GraphicsLayer = __esri.GraphicsLayer;
export let GroupLayer = _GroupLayer;
export type GroupLayer = __esri.GroupLayer;
export let Home = _Home;
export type Home = __esri.Home;
export let LayerList = _LayerList;
export type LayerList = __esri.LayerList;
export let Locate = _Locate;
export type Locate = __esri.Locate;
export let Map = _Map;
export type Map = __esri.Map;
export let MapImageLayer = _MapImageLayer;
export type MapImageLayer = __esri.MapImageLayer;
export let MapView = _MapView;
export type MapView = __esri.MapView;
export let Measurement = _Measurement;
export type Measurement = __esri.Measurement;
export let Point = _Point;
export type Point = __esri.Point;
export let Polygon = _Polygon;
export type Polygon = __esri.Polygon;
export let Circle = _Circle;
export type Circle = __esri.Circle;
export let Polyline = _Polyline;
export type Polyline = __esri.Polyline;
export let Query = _Query;
export type Query = __esri.Query;
export let QueryTask = _QueryTask;
export type QueryTask = __esri.QueryTask;
export let RasterData = _RasterData;
export type RasterData = __esri.RasterData;
export let ScaleBar = _ScaleBar;
export type ScaleBar = __esri.ScaleBar;
export let SceneView = _SceneView;
export type SceneView = __esri.SceneView;
export let Search = _Search;
export type Search = __esri.Search;
export let SimpleFillSymbol = _SimpleFillSymbol;
export type SimpleFillSymbol = __esri.SimpleFillSymbol;
export let SimpleLineSymbol = _SimpleLineSymbol;
export type SimpleLineSymbol = __esri.SimpleLineSymbol;
export let SimpleMarkerSymbol = _SimpleMarkerSymbol;
export type SimpleMarkerSymbol = __esri.SimpleMarkerSymbol;
export let SimpleRenderer = _SimpleRenderer;
export type SimpleRenderer = __esri.SimpleRenderer;
export let Sketch = _Sketch;
export type Sketch = __esri.Sketch;
export let SketchViewModel = _SketchViewModel;
export type SketchViewModel = __esri.SketchViewModel;
export let Slider = _Slider;
export type Slider = __esri.Slider;
export let SnappingOptions = _SnappingOptions;
export type SnappingOptions = __esri.SnappingOptions;
export let SpatialReference = _SpatialReference;
export type SpatialReference = __esri.SpatialReference;
export let Symbol = _Symbol;
export type Symbol = __esri.Symbol;
export let TileLayer = _TileLayer;
export type TileLayer = __esri.TileLayer;
export let Widget = _Widget;
export type Widget = __esri.Widget;
export let Field = _Field;
export type Field = __esri.Field;
export type FieldProperties = __esri.FieldProperties;
// //nifty trick that may allow for lazy loading of @arcgis/core types later.
// export let Widget: __esri.WidgetConstructor = (undefined as unknown) as __esri.WidgetConstructor;

export async function loadEsriLoaderTypes(): Promise<void> {
  // const [asdf] = await loadModules(['asdf']);

  const [
    _esriRequest,

    _esriGeometryEngine,
    _esriProjection,
    _esriWatchUtils,

    _esriIdentityManager,

    _Attribution,
    _BasemapGallery,
    _BasemapToggle,
    _ClassBreaksRenderer,
    _Compass,
    _CoordinateConversion,
    _Draw,
    _Editor,
    _Expand,
    _Extent,
    _FeatureLayer,
    _ImageryLayer,
    _FeatureSet,
    _GeoJSONLayer,
    _Geometry,
    _Geoprocessor,
    _Graphic,
    _GraphicsLayer,
    _GroupLayer,
    _Home,
    _LayerList,
    _Locate,
    _Map,
    _MapImageLayer,
    _MapView,
    _Measurement,
    _Point,
    _Polygon,
    _Circle,
    _Polyline,
    _Query,
    _QueryTask,
    _RasterData,
    _ScaleBar,
    _SceneView,
    _Search,
    _SimpleFillSymbol,
    _SimpleLineSymbol,
    _SimpleMarkerSymbol,
    _SimpleRenderer,
    _Sketch,
    _SketchViewModel,
    _Slider,
    _SpatialReference,
    _Symbol,
    _TileLayer,
    _Widget,
    _Field,
  ] = await loadModules([
    'esri/request',

    'esri/geometry/geometryEngine',
    'esri/geometry/projection',
    'esri/core/watchUtils',

    'esri/identity/IdentityManager',

    'esri/widgets/Attribution',
    'esri/widgets/BasemapGallery',
    'esri/widgets/BasemapToggle',
    'esri/renderers/ClassBreaksRenderer',
    'esri/widgets/Compass',
    'esri/widgets/CoordinateConversion',
    'esri/views/draw/Draw',
    'esri/widgets/Editor',
    'esri/widgets/Expand',
    'esri/geometry/Extent',
    'esri/layers/FeatureLayer',
    'esri/layers/ImageryLayer',
    'esri/rest/support/FeatureSet',
    'esri/layers/GeoJSONLayer',
    'esri/geometry/Geometry',
    'esri/tasks/Geoprocessor',
    'esri/Graphic',
    'esri/layers/GraphicsLayer',
    'esri/layers/GroupLayer',
    'esri/widgets/Home',
    'esri/widgets/LayerList',
    'esri/widgets/Locate',
    'esri/Map',
    'esri/layers/MapImageLayer',
    'esri/views/MapView',
    'esri/widgets/Measurement',
    'esri/geometry/Point',
    'esri/geometry/Polygon',
    'esri/geometry/Polyline',
    'esri/rest/support/Query',
    'esri/tasks/QueryTask',
    'esri/rest/support/RasterData',
    'esri/widgets/ScaleBar',
    'esri/views/SceneView',
    'esri/widgets/Search',
    'esri/symbols/SimpleFillSymbol',
    'esri/symbols/SimpleLineSymbol',
    'esri/symbols/SimpleMarkerSymbol',
    'esri/renderers/SimpleRenderer',
    'esri/widgets/Sketch',
    'esri/widgets/Sketch/SketchViewModel',
    'esri/widgets/Slider',
    'esri/geometry/SpatialReference',
    'esri/symbols/Symbol',
    'esri/layers/TileLayer',
    'esri/widgets/Widget',
    'esri/layers/support/Field',
  ]);

  esriRequest = _esriRequest;

  esriGeometryEngine = _esriGeometryEngine;
  esriProjection = _esriProjection;
  esriWatchUtils = _esriWatchUtils;
  await esriProjection.load(); // eager load esriProjection so it is ready for use

  esriIdentityManager = _esriIdentityManager;

  Attribution = _Attribution;
  BasemapGallery = _BasemapGallery;
  BasemapToggle = _BasemapToggle;
  ClassBreaksRenderer = _ClassBreaksRenderer;
  Compass = _Compass;
  CoordinateConversion = _CoordinateConversion;
  Draw = _Draw;
  Editor = _Editor;
  Expand = _Expand;
  Extent = _Extent;
  FeatureLayer = _FeatureLayer;
  ImageryLayer = _ImageryLayer;
  FeatureSet = _FeatureSet;
  GeoJSONLayer = _GeoJSONLayer;
  Geometry = _Geometry;
  Geoprocessor = _Geoprocessor;
  Graphic = _Graphic;
  GraphicsLayer = _GraphicsLayer;
  GroupLayer = _GroupLayer;
  Home = _Home;
  LayerList = _LayerList;
  Locate = _Locate;
  Map = _Map;
  MapImageLayer = _MapImageLayer;
  MapView = _MapView;
  Measurement = _Measurement;
  Point = _Point;
  Polygon = _Polygon;
  Circle = _Circle;
  Polyline = _Polyline;
  Query = _Query;
  QueryTask = _QueryTask;
  RasterData = _RasterData;
  ScaleBar = _ScaleBar;
  SceneView = _SceneView;
  Search = _Search;
  SimpleFillSymbol = _SimpleFillSymbol;
  SimpleLineSymbol = _SimpleLineSymbol;
  SimpleMarkerSymbol = _SimpleMarkerSymbol;
  SimpleRenderer = _SimpleRenderer;
  Sketch = _Sketch;
  SketchViewModel = _SketchViewModel;
  Slider = _Slider;
  SnappingOptions = _SnappingOptions;
  SpatialReference = _SpatialReference;
  Symbol = _Symbol;
  TileLayer = _TileLayer;
  Widget = _Widget;
}

export async function loadArcGisCoreTypes(): Promise<void> {
  esriRequest = (await import('@arcgis/core/request')).default;

  esriGeometryEngine = await import('@arcgis/core/geometry/geometryEngine');
  esriProjection = await import('@arcgis/core/geometry/projection');
  esriWatchUtils = await import('@arcgis/core/core/watchUtils');

  await esriProjection.load(); // eager load esriProjection so it is ready for use

  esriIdentityManager = (await import('@arcgis/core/identity/IdentityManager')).default;

  Attribution = (await import('@arcgis/core/widgets/Attribution')).default;
  BasemapGallery = (await import('@arcgis/core/widgets/BasemapGallery')).default;
  BasemapToggle = (await import('@arcgis/core/widgets/BasemapToggle')).default;
  ClassBreaksRenderer = (await import('@arcgis/core/renderers/ClassBreaksRenderer')).default;
  Compass = (await import('@arcgis/core/widgets/Compass')).default;
  CoordinateConversion = (await import('@arcgis/core/widgets/CoordinateConversion')).default;
  Draw = (await import('@arcgis/core/views/draw/Draw')).default;
  Editor = (await import('@arcgis/core/widgets/Editor')).default;
  Expand = (await import('@arcgis/core/widgets/Expand')).default;
  Extent = (await import('@arcgis/core/geometry/Extent')).default;
  FeatureLayer = (await import('@arcgis/core/layers/FeatureLayer')).default;
  ImageryLayer = (await import('@arcgis/core/layers/ImageryLayer')).default;
  FeatureSet = (await import('@arcgis/core/rest/support/FeatureSet')).default;
  GeoJSONLayer = (await import('@arcgis/core/layers/GeoJSONLayer')).default;
  Geometry = (await import('@arcgis/core/geometry/Geometry')).default;
  Geoprocessor = (await import('@arcgis/core/tasks/Geoprocessor')).default;
  Graphic = (await import('@arcgis/core/Graphic')).default;
  GraphicsLayer = (await import('@arcgis/core/layers/GraphicsLayer')).default;
  GroupLayer = (await import('@arcgis/core/layers/GroupLayer')).default;
  Home = (await import('@arcgis/core/widgets/Home')).default;
  LayerList = (await import('@arcgis/core/widgets/LayerList')).default;
  Map = (await import('@arcgis/core/Map')).default;
  MapImageLayer = (await import('@arcgis/core/layers/MapImageLayer')).default;
  MapView = (await import('@arcgis/core/views/MapView')).default;
  Measurement = (await import('@arcgis/core/widgets/Measurement')).default;
  Point = (await import('@arcgis/core/geometry/Point')).default;
  Polygon = (await import('@arcgis/core/geometry/Polygon')).default;
  Circle = (await import('@arcgis/core/geometry/Circle')).default;
  Polyline = (await import('@arcgis/core/geometry/Polyline')).default;
  Query = (await import('@arcgis/core/rest/support/Query')).default;
  QueryTask = (await import('@arcgis/core/tasks/QueryTask')).default;
  RasterData = (await import('@arcgis/core/rest/support/RasterData')).default;
  ScaleBar = (await import('@arcgis/core/widgets/ScaleBar')).default;
  SceneView = (await import('@arcgis/core/views/SceneView')).default;
  Search = (await import('@arcgis/core/widgets/Search')).default;
  SimpleFillSymbol = (await import('@arcgis/core/symbols/SimpleFillSymbol')).default;
  SimpleLineSymbol = (await import('@arcgis/core/symbols/SimpleLineSymbol')).default;
  SimpleMarkerSymbol = (await import('@arcgis/core/symbols/SimpleMarkerSymbol')).default;
  SimpleRenderer = (await import('@arcgis/core/renderers/SimpleRenderer')).default;
  Sketch = (await import('@arcgis/core/widgets/Sketch')).default;
  SketchViewModel = (await import('@arcgis/core/widgets/Sketch/SketchViewModel')).default;
  Slider = (await import('@arcgis/core/widgets/Slider')).default;
  SnappingOptions = (await import('@arcgis/core/views/interactive/snapping/SnappingOptions')).default;
  SpatialReference = (await import('@arcgis/core/geometry/SpatialReference')).default;
  Symbol = (await import('@arcgis/core/symbols/Symbol')).default;
  TileLayer = (await import('@arcgis/core/layers/TileLayer')).default;
  Widget = (await import('@arcgis/core/widgets/Widget')).default;
  Field = (await import('@arcgis/core/layers/support/Field')).default;
}

export function clearLoadedTypes() {
  esriRequest = undefined as any;

  esriGeometryEngine = undefined as any;
  esriProjection = undefined as any;
  esriWatchUtils = undefined as any;

  esriIdentityManager = undefined as any;

  Attribution = undefined as any;
  BasemapGallery = undefined as any;
  BasemapToggle = undefined as any;
  ClassBreaksRenderer = undefined as any;
  Compass = undefined as any;
  CoordinateConversion = undefined as any;
  Draw = undefined as any;
  Editor = undefined as any;
  Expand = undefined as any;
  Extent = undefined as any;
  FeatureLayer = undefined as any;
  ImageryLayer = undefined as any;
  FeatureSet = undefined as any;
  GeoJSONLayer = undefined as any;
  Geometry = undefined as any;
  Geoprocessor = undefined as any;
  Graphic = undefined as any;
  GraphicsLayer = undefined as any;
  GroupLayer = undefined as any;
  Home = undefined as any;
  LayerList = undefined as any;
  Locate = undefined as any;
  Map = undefined as any;
  MapImageLayer = undefined as any;
  MapView = undefined as any;
  Measurement = undefined as any;
  Point = undefined as any;
  Polygon = undefined as any;
  Circle = undefined as any;
  Polyline = undefined as any;
  Query = undefined as any;
  QueryTask = undefined as any;
  RasterData = undefined as any;
  ScaleBar = undefined as any;
  SceneView = undefined as any;
  Search = undefined as any;
  SimpleFillSymbol = undefined as any;
  SimpleLineSymbol = undefined as any;
  SimpleMarkerSymbol = undefined as any;
  SimpleRenderer = undefined as any;
  Sketch = undefined as any;
  SketchViewModel = undefined as any;
  Slider = undefined as any;
  SnappingOptions = undefined as any;
  SpatialReference = undefined as any;
  Symbol = undefined as any;
  TileLayer = undefined as any;
  Widget = undefined as any;
  Field = undefined as any;
}
